module.exports = __webpack_public_path__ + "img/home--offer--personalized.7b276247.svg";